/* CENIT · Estrellas en el fondo de cada sección.
   · Se crean cuando la sección entra en pantalla (IntersectionObserver, sin listeners de scroll).
   · Solo se animan mientras la sección está visible.
   · Cantidad según el tamaño de la sección; menos en móvil.
   · Con "reducir movimiento" quedan quietas.
   Estilos: assets/cenit-global-light.css (.cenit-stars) */
(function () {
  if (window.cenitStarsReady || !('IntersectionObserver' in window)) return;
  window.cenitStarsReady = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mobile = window.matchMedia('(max-width: 749px)').matches;

  function rand(a, b) { return a + Math.random() * (b - a); }

  function fill(sec) {
    if (sec.dataset.cenitStars) return;
    sec.dataset.cenitStars = '1';
    var r = sec.getBoundingClientRect();
    var area = r.width * r.height;
    if (area < 30000) return;

    var n = Math.round(Math.max(12, Math.min(mobile ? 26 : 58, area / (mobile ? 15000 : 24000))));
    var layer = document.createElement('div');
    layer.className = 'cenit-stars';
    layer.setAttribute('aria-hidden', 'true');
    var frag = document.createDocumentFragment();

    for (var i = 0; i < n; i++) {
      var el = document.createElement('i');
      var kind = Math.random();
      if (kind < 0.3) el.className = 'is-spark';
      else if (kind < 0.48) el.className = 'is-glow';
      var size = el.className === 'is-spark' ? rand(9, 17) : el.className === 'is-glow' ? rand(3.5, 5.5) : rand(2, 3.6);
      el.style.cssText =
        'left:' + rand(1, 99).toFixed(2) + '%;top:' + rand(2, 98).toFixed(2) + '%;' +
        '--s:' + size.toFixed(1) + 'px;--d:' + rand(3, 7.5).toFixed(2) + 's;' +
        '--delay:-' + rand(0, 8).toFixed(2) + 's;--peak:' + rand(0.7, 1).toFixed(2);
      frag.appendChild(el);
    }

    /* Estrella fugaz ocasional (no en todas las secciones) */
    if (!reduce && Math.random() < 0.6) {
      var s = document.createElement('b');
      s.className = 'cenit-stars__shoot';
      s.style.cssText = 'left:' + rand(5, 60).toFixed(1) + '%;top:' + rand(8, 55).toFixed(1) + '%;' +
        '--d:' + rand(9, 16).toFixed(1) + 's;--delay:' + rand(1, 9).toFixed(1) + 's';
      frag.appendChild(s);
    }

    layer.appendChild(frag);
    sec.classList.add('has-stars');
    sec.insertBefore(layer, sec.firstChild);
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) fill(e.target);
      e.target.classList.toggle('is-lit', e.isIntersecting);
    });
  }, { rootMargin: '200px 0px' });

  function watch(scope) {
    (scope || document).querySelectorAll('#MainContent > .shopify-section, .shopify-section-group-footer-group').forEach(function (sec) {
      if (!sec.hasAttribute('data-cenit-no-stars')) io.observe(sec);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { watch(); });
  else watch();
  document.addEventListener('shopify:section:load', function (e) {
    var sec = e.target.closest ? e.target.closest('.shopify-section') || e.target : e.target;
    delete sec.dataset.cenitStars;
    io.observe(sec);
  });
})();
